function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.353 4.937v118.917h97.346V4.937zm10.73 14.803h75.885v17.224H26.083zm25.974 25.038h49.911v64.273h-49.91zm-25.975.054h19.37v16.124h-19.37zm0 24.048h19.37v16.124h-19.37zm0 24.048h19.37v16.123h-19.37z",
    style: {
      fill: "#61b8dd"
    }
  }));
};
export default SvgIcon;